module.exports = __webpack_public_path__ + "static/media/r12.31dc70c8.png";